import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';

const AdminLink = () => {
  // Check if user is authenticated
  const isAuthenticated = sessionStorage.getItem('adminAuthenticated') === 'true';

  if (!isAuthenticated) {
    return null;
  }

  return (
    <Link 
      to="/admin/dashboard" 
      className="nav-link flex items-center text-client-yellow hover:text-client-teal"
      aria-label="Admin Dashboard"
    >
      <Lock size={16} className="mr-1" />
      Admin
    </Link>
  );
};

export default AdminLink; 